module.exports = __webpack_public_path__ + "img/world.7b4a1703.png";